import PopularKeywords from '@/_application/core/components/commons/popular-keywords/popular-keywords';
import {useTranslation} from 'next-i18next';
import {Keywords} from '__generated__/__types__';

interface PopularKeywordsHomeProps {
    /**
     * Pre-fetched hashtags from server-side (for ISR/SSR)
     */
    serverHashtags?: Keywords[];
}

function PopularKeywordsHome({serverHashtags}: PopularKeywordsHomeProps) {
    const {t} = useTranslation('common');
    const hashTags = (serverHashtags ?? []).filter(item => item?.tag_name && item?.tag_url);

    if (hashTags.length === 0) return null;

    return (
        <PopularKeywords
            hashTags={hashTags}
            title={t('popular-keyword', 'Từ khóa được tìm kiếm nhiều')}
            className="mb-5 min-h-[10.375rem] w-full sm:w-[698px] lg:w-[950px] xl:w-[1196px]"
        />
    );
}

export default PopularKeywordsHome;
